
import { useParsedFieldProps } from "./useParsedFieldProps";
import { EXCEL_MAXIMUM_CELL_LENGTH } from "../../../helpers/FormValidator";
import Field, { FIELD_MODE_FIELDSET } from "../Field";
import { EMAIL_WITH_CONSENTS } from "../SchemaTypes";
import EmailWithConsentsInput from "../../Input/EmailWithConsentsInput";

const EmailWithConsentsField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const schema = {
    type: EMAIL_WITH_CONSENTS,
    parent,
    validations: {
      required,
      email: true,
      length: { maximum: EXCEL_MAXIMUM_CELL_LENGTH }
    }
  };

  return (
    <Field {...fieldProps} schema={schema} fieldMode={FIELD_MODE_FIELDSET}>
      <EmailWithConsentsInput {...inputProps} autoComplete="email" />
    </Field>
  );
};

export default EmailWithConsentsField;
